(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conjunt-mofo"] && !Shopify.designMode) return;
  try {
    
    setTimeout(() => {
        $(".produtos-conjunto").slick({
            dots: true,
            arrows: false,
            slidesToShow: 1
        });
    }, 1500);
    $('.button-option').click(function() {
        if(!$(this).hasClass('active-conjunt')) {
            $('.button-option').removeClass('active-conjunt');
            $(this).addClass('active-conjunt');

            let dots = document.querySelectorAll('.produtos-conjunto .slick-dots li');

            if($(this).hasClass('button-product-one')) {
                dots[0].click();
            } else if($(this).hasClass('button-product-two')) {
                dots[1].click();
            }

        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  function getMetafield() {
    const products = [];
    const cartItems = document.querySelectorAll('#cart .cart-item');
    if(cartItems){
      cartItems.forEach((cartItem, index) => {
      const metafieldElement = cartItem.querySelector('.product-metafield');

      if (!metafieldElement) {
        return;
      }

      const isTintaComChip = metafieldElement.getAttribute('data-metafield');
      const title = metafieldElement.getAttribute('data-product');
      const option = metafieldElement.getAttribute('data-option');

      if (!isTintaComChip) {
        return;
      }

      const existsProduct = products.find(p => p.title === title);
      const input = cartItem.querySelector('.quantity__input');

      if (existsProduct) {

        if (option.toLowerCase().includes('cor')) {
          existsProduct.cores.push(input);
        } else {
          existsProduct.chips.push(input);
        }
        return;
      }

      const product = {
        title,
        cores: [],
        chips: [],
        qtyCores: 0,
        qtyChips: 0,
      };

      if (option.toLowerCase().includes('cor')) {
        product.cores.push(input);
      } else {
        product.chips.push(input);
      }

      products.push(product);
    });

    products.forEach(product => {
      product.qtyCores = sumQuantities(product.cores);
      product.qtyChips = sumQuantities(product.chips);

      product.cores.forEach(input => {
        addInputListener(input, product, 'qtyCores', 'cores',products);
      });

      product.chips.forEach(input => {
        addInputListener(input, product, 'qtyChips', 'chips',products);
      });
    });

    setTimeout(()=> buttonLock(products), 500);
    }
  }

  function buttonLock( products ){
    //const msgInvalid = 'A quantidade de CHIPS deve ser igual ou menor que a de TINTAS'
    const cartButton = document.querySelector('#checkout');
    const paypalButton = document.querySelector('shopify-paypal-button');
    const warningContainer = document.querySelector('#checkout-warning');
    const warning = warningContainer.querySelector('span');

    for (let product of products){
      const validQuantity = product.qtyCores >= product.qtyChips;
      if(!validQuantity){
        //warning.innerText = msgInvalid;
        warningContainer.style.visibility = 'visible';
        cartButton.classList.add('not-allowed');
        cartButton.disabled = true;
        paypalButton.classList.add('not-allowed');
        paypalButton.disabled = true;
        break;
      }
      warningContainer.style.visibility = 'hidden';
      cartButton.classList.remove('not-allowed');
      cartButton.disabled = false;
      paypalButton.classList.remove('not-allowed');
      paypalButton.disabled = false;
    }
  }

  function addInputListener(input, product, quantity, type, products) {
    let previousValue = input.value;
    input.addEventListener('input', () => {
      const currentValue = parseInt(input.value) || 0;
      if (currentValue !== previousValue) {
        previousValue = currentValue;
        product[quantity] = sumQuantities(product[type]);
        buttonLock(products);
      }
    });
  }

  function sumQuantities(inputs) {
    return inputs.reduce((total, input) => {
      const value = parseInt(input.value) || 0;
      return total + value;
    }, 0);
  }

  if (document.readyState === 'complete') {
    getMetafield();
  } else {
    window.addEventListener('load', getMetafield);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  function getMetafield() {
    const products = [];
    const cartItems = document.querySelectorAll('#cart .cart-item');
    if(cartItems){
      cartItems.forEach((cartItem, index) => {
      const metafieldElement = cartItem.querySelector('.product-metafield');

      if (!metafieldElement) {
        return;
      }

      const isTintaComChip = metafieldElement.getAttribute('data-metafield');
      const title = metafieldElement.getAttribute('data-product');
      const option = metafieldElement.getAttribute('data-option');

      if (!isTintaComChip) {
        return;
      }

      const existsProduct = products.find(p => p.title === title);
      const input = cartItem.querySelector('.quantity__input');

      if (existsProduct) {

        if (option.toLowerCase().includes('cor')) {
          existsProduct.cores.push(input);
        } else {
          existsProduct.chips.push(input);
        }
        return;
      }

      const product = {
        title,
        cores: [],
        chips: [],
        qtyCores: 0,
        qtyChips: 0,
      };

      if (option.toLowerCase().includes('cor')) {
        product.cores.push(input);
      } else {
        product.chips.push(input);
      }

      products.push(product);
    });

    products.forEach(product => {
      product.qtyCores = sumQuantities(product.cores);
      product.qtyChips = sumQuantities(product.chips);

      product.cores.forEach(input => {
        addInputListener(input, product, 'qtyCores', 'cores',products);
      });

      product.chips.forEach(input => {
        addInputListener(input, product, 'qtyChips', 'chips',products);
      });
    });

    setTimeout(()=> buttonLock(products), 500);
    }
  }

  function buttonLock( products ){
    //const msgInvalid = 'A quantidade de CHIPS deve ser igual ou menor que a de TINTAS'
    const cartButton = document.querySelector('#checkout');
    const paypalButton = document.querySelector('shopify-paypal-button');
    const warningContainer = document.querySelector('#checkout-warning');
    const warning = warningContainer.querySelector('span');

    for (let product of products){
      const validQuantity = product.qtyCores >= product.qtyChips;
      if(!validQuantity){
        //warning.innerText = msgInvalid;
        warningContainer.style.visibility = 'visible';
        cartButton.classList.add('not-allowed');
        cartButton.disabled = true;
        paypalButton.classList.add('not-allowed');
        paypalButton.disabled = true;
        break;
      }
      warningContainer.style.visibility = 'hidden';
      cartButton.classList.remove('not-allowed');
      cartButton.disabled = false;
      paypalButton.classList.remove('not-allowed');
      paypalButton.disabled = false;
    }
  }

  function addInputListener(input, product, quantity, type, products) {
    let previousValue = input.value;
    input.addEventListener('input', () => {
      const currentValue = parseInt(input.value) || 0;
      if (currentValue !== previousValue) {
        previousValue = currentValue;
        product[quantity] = sumQuantities(product[type]);
        buttonLock(products);
      }
    });
  }

  function sumQuantities(inputs) {
    return inputs.reduce((total, input) => {
      const value = parseInt(input.value) || 0;
      return total + value;
    }, 0);
  }

  if (document.readyState === 'complete') {
    getMetafield();
  } else {
    window.addEventListener('load', getMetafield);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 
  const intervalTime = 375;
  const inputValues = {
    cores: 0,
    chips: 0
  }

  function sumQuantities(obj, objKey, inputs, callback) {
    let total = 0;
    inputs.forEach((input) => {
      total += parseInt(input.value); // Supondo que o valor seja numérico
    });
    obj[objKey] = total;
    callback();
  }
  
  function listenToQuantity() {
    const interval = setInterval(() => {
      const addButton = document.querySelector('#multivariants_add_to_cart_button');

      const blocks = document.querySelectorAll('.multivariants_block_last_holder');
      if (blocks.length > 0) {
        clearInterval(interval); // Para a verificação

        const cores = [];
        const chips = [];

        blocks.forEach((block) => {
          // Seleciona o label e input
          const labelElement = block.querySelector('.multivariants_block_last_holder_labels .multivariants_block_label .mkmid_m');

          const input = block.querySelector('.multivariants_block_qty_holder input');
         

          if (labelElement && input) {
            const label = labelElement.textContent.toLowerCase();

            // Verifica e separa em cores e chips
            if (label.includes('cor')) {
              cores.push(input);
            } else if (label.includes('chip')) {
              chips.push(input);
            }
          }
        });

        cores.forEach((input,index)=>{
          let value = input.value;
          setInterval(()=>{
            if(input.value !== value){
              value = input.value;
              sumQuantities(inputValues, 'cores', cores, ()=>{ buttonLock(addButton)});
            }
          }, intervalTime);
        });
        chips.forEach((input,index)=>{
          let value = input.value;
          setInterval(()=>{
            if(input.value !== value){
              value = input.value;
              sumQuantities(inputValues, 'chips', chips,()=>{ buttonLock(addButton)});
            }
          }, intervalTime);
        });
      }
    }, 500); // Verifica a cada 500ms
  }



  function getMetacamp() {
    // Seleciona o elemento com o metacampo
    const metacampElement = document.getElementById('product-metacamp');

    if (!metacampElement) {
      return;
    }

    // Obtém o metcampo do atributo data-metacamp
    const metacampAttribute = metacampElement.getAttribute('data-metacamp');
    if (!metacampAttribute) {
      return;
    }
      listenToQuantity();

  }

  function buttonLock(button) {
    const msgQuantity= 'A quantidade de itens deve ser maior que zero';
    const msgInvalid = 'A quantidade de CHIPS deve ser igual ou menor que a de TINTAS'

    const productContainer = document.querySelector('.product__info-container');

    const alertElement = productContainer.querySelector('#alertNotMatchingQuantities');
    const validQuantity = inputValues.cores == 0 && inputValues.chips == 0;

    // Verifica se a quantidade de chips é maior que a de tintas ou se ambas são zero
    if (inputValues.cores < inputValues.chips || validQuantity) {
        button.disabled = true;

        // Se as quantidades não forem válidas e o alerta ainda não existir
        if (!validQuantity && !alertElement) {
            const container = document.createElement('div');
            container.classList.add('alert-container');
            const alertBox = document.createElement('span');
            alertBox.id = 'alertNotMatchingQuantities';

            const textNode = document.createTextNode(msgInvalid);
            alertBox.appendChild(textNode);

            alertBox.classList.add('multivariants_setbox_alert'); // Corrige o método
            alertBox.classList.add('alert-box'); // Corrige o método

            container.appendChild(alertBox);
            productContainer.appendChild(container);
            return;
        }
        if (alertElement && validQuantity) {
          alertElement.innerText = msgQuantity;
          return
        }
        alertElement.innerText = msgInvalid;
        return;
    }

    // Caso as quantidades sejam válidas
    button.disabled = false;

    // Remove o alerta, se ele existir
    if (alertElement) {
        alertElement.remove();
    }
  }




  if (document.readyState === 'complete') {
    getMetacamp();
  } else {
    window.addEventListener("load", () => {
      getMetacamp();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
